if (typeof (angular) !== "undefined") {
    angular.module("expenseReportViewApp", []);
    angular.module("expenseReportViewApp").controller("expenseReportViewController", ["$scope", "$locale", "$http", function ($scope, $locale, $http) {
        function initSelectedExecutives() {
            var execs = $scope.filterData.Executives;
            var execSelector = [];
            for (var i = 0; i < execs.length; i++) {
                execSelector.push({ Name: execs[i], Selected: true });
            }
            return execSelector;
        };


        $scope.toggleRefiners = function toggleRefiners() {
            const element = document.getElementById("expense-refiners"); 
            const button = document.getElementById("toggler");
            element.classList.toggle("open");
            button.classList.toggle("open");
            if (button.classList.contains("open")) {
                button.setAttribute('aria-expanded', 'true');
            } else {
                button.setAttribute('aria-expanded', 'false');
            }
        }

        function initTimeSpan() {
            var oldest = new Date($scope.filterData.EarliestDate);
            var youngest = new Date($scope.filterData.LatestDate);

            var now = new Date();
            oldest = new Date(oldest);
            youngest = new Date(youngest);

            var yearSelection = [];
            for (var i = oldest.getFullYear() ; i <= now.getFullYear() ; i++) {
                yearSelection.push(i);
            }

            return {
                MonthNames: $locale.DATETIME_FORMATS.STANDALONEMONTH,
                MonthSelection: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                YearSelection: yearSelection,
                StartMonth: 0,
                StartYear: oldest.getFullYear(),
                EndMonth: now.getMonth(),
                EndYear: now.getFullYear()
            };
        };

        $scope.monthName = function (monthNumber) {
            return $scope.selectedTimeSpan.MonthNames[monthNumber];
        };


        function checkDateBounds() {
            if ($scope.selectedTimeSpan.EndYear == $scope.selectedTimeSpan.StartYear) {
                if ($scope.selectedTimeSpan.StartMonth > $scope.selectedTimeSpan.EndMonth)
                    $scope.selectedTimeSpan.StartMonth = $scope.selectedTimeSpan.EndMonth;
            }
        };

        $scope.disableUpperMonths = function (month) {
            if ($scope.selectedTimeSpan.StartYear == $scope.selectedTimeSpan.EndYear) {
                if (month > $scope.selectedTimeSpan.EndMonth)
                    return true;
            }
            return false;
        };

        $scope.disableUpperYears = function (year) {
            if (year > $scope.selectedTimeSpan.EndYear) {
                return true;
            }
            return false;
        };

        $scope.disableLowerMonths = function (month) {
            if ($scope.selectedTimeSpan.StartYear == $scope.selectedTimeSpan.EndYear) {
                if (month < $scope.selectedTimeSpan.StartMonth)
                    return true;
            }
            return false;
        };

        $scope.disableLowerYears = function (year) {
            if (year < $scope.selectedTimeSpan.StartYear) {
                return true;
            }
            return false;
        };

        $scope.setOrder = function (sortByString) {
            $scope.reverse = !$scope.reverse;
            $scope.order = sortByString;
        };

        $scope.fileName = function (url) {
            if (url) {
                var m = url.toString().match(/\/([^\/?,#]+)[^\/]*$/);
                if (m && m.length > 1) {
                    return m[1];
                }
            }
            return "";
        };

        function getPages () {
            var pageNumbers = [];
            var pageAmount = $scope.reportData.Hits / $scope.pagiAmount + ($scope.reportData.Hits % $scope.pagiAmount != 0 ? 1 : 0);
            for (var i = 1; i <= pageAmount; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers;
        };

        function getPagiSections() {
            return Math.floor($scope.pagiPages.length / $scope.pagiSectionSize) + ($scope.pagiPages.length % $scope.pagiSectionSize != 0 ? 1 : 0);
        }

        function getReports(rrid, amount, start, dateType) {
            $scope.loading = true;
            iSpinner(true);
            var selectedStartDate = new Date($scope.selectedTimeSpan.StartYear, $scope.selectedTimeSpan.StartMonth, 1, 0).getTime();
            var selectedEndDate = new Date($scope.selectedTimeSpan.EndYear, $scope.selectedTimeSpan.EndMonth + 1, 0, 23, 59, 59, 0).getTime();

            var execs = [];
            for (var i = 0; i < $scope.selectedExecutives.length; i++) {
                if ($scope.selectedExecutives[i].Selected == true)
                    execs.push($scope.selectedExecutives[i].Name);
            }
            

            var reportParams = { Executives: execs, EarliestDate: selectedStartDate, LatestDate: selectedEndDate, TotalHits: 0, DateType: dateType };
            $http.post("/api/expensereports/" + rrid + "?amount=" + amount + "&start=" + start, reportParams)
            .then(function successCallback(response) {
                $scope.reportData = response.data;
                $scope.reportDataValid = (typeof $scope.reportData !== "undefined" && $scope.reportData !== null);
            }, function errorCallback() {
                $scope.reportDataValid = false;
                $scope.error = true;
            }).then(function () {
                $scope.loading = false;
                if ($scope.reportDataValid) {
                    $scope.pagiPages = getPages();
                    $scope.totalPagiSections = getPagiSections();
                    if (typeof $scope.reportData.Reports !== "undefined" && $scope.reportData.Reports !== null && (Object.keys($scope.reportData.Reports).length > 0)) {
                        $scope.noResults = false;
                    } else {
                        $scope.noResults = true;
                    }
                } else {
                    $scope.error = true;
                }

                iSpinner(false);
            })
        };

        $scope.selectionChanged = function () {
            iSpinner(true);
            checkDateBounds();
            $scope.pagiIndex = 0;
            $scope.pagiSelected = 1;
            $scope.selectedPagiSection = 1;
            getReports(rrid, $scope.pagiAmount, $scope.pagiIndex, $scope.filterData.DateType);
        };

        $scope.pagiHits = function () {
            if ($scope.reportData.Hits < $scope.pagiAmount)
                return $scope.reportData.Hits;
            if ($scope.pagiIndex + $scope.pagiAmount > $scope.reportData.Hits)
                return $scope.reportData.Hits;

            return $scope.pagiIndex + $scope.pagiAmount;
        };

        $scope.pagiChanged = function (pageNumber) {
            $scope.pagiSelected = pageNumber;
            $scope.pagiIndex = (pageNumber - 1) * $scope.pagiAmount;

            $scope.selectedPagiSection = Math.floor(pageNumber / $scope.pagiSectionSize) + (pageNumber % $scope.pagiSectionSize != 0 ? 1 : 0)

            if ($scope.pagiIndex < 0)
                $scope.pagiIndex = 0;

            if ($scope.pagiIndex > $scope.reportData.Hits)
                $scope.pagiIndex -= $scope.pagiAmount;

            getReports(rrid, $scope.pagiAmount, $scope.pagiIndex, $scope.filterData.DateType);
        };

        $scope.sectionChanged = function (sectionNumber) {             
            if (sectionNumber < 1)
                $scope.selectedPagiSection = 1;
            else if (sectionNumber > $scope.totalPagiSections)
                $scope.selectedPagiSection = $scope.totalPagiSections;
            else
                $scope.selectedPagiSection = sectionNumber;

            $scope.pagiSelected = (($scope.selectedPagiSection - 1) * $scope.pagiSectionSize) + 1;
            $scope.pagiIndex = ($scope.pagiSelected - 1) * $scope.pagiAmount;

            getReports(rrid, $scope.pagiAmount, $scope.pagiIndex, $scope.filterData.DateType);
        }

        $scope.paginationFilter = function (page) {
            var value = page / $scope.pagiSectionSize;
            value = value % 1 == 0 ? value : Math.floor(value + 1);
            return (value == $scope.selectedPagiSection);
        }

        $scope.dateTypeSelect = function (item) {
            if ($scope.filterData.DateType === 'TravelDate')
                return item.TravelDate;
            else
                return item.ExpenseDate;
        }

        //Haetaan filtterille tiedot ja ensimmäiset raportit
        function init() {
            if (typeof rrid === 'number' && typeof pagiAmount === 'number' && typeof rDateType === 'string') {
                //Sivupropertyistä saatavat parametrit:
                $scope.pagiAmount = pagiAmount;

                //Filtteri- ja sivutusmuuttujat
                $scope.pagiSectionSize = 10;
                $scope.selectedPagiSection = 1;
                $scope.totalPagiSections;
                $scope.pagiIndex = 0;
                $scope.pagiSelected = 1;
                $scope.pagiPages;
                $scope.reportData;
                $scope.filterData;

                $scope.rDateType = rDateType;
                $scope.order = rDateType;
                $scope.reverse = false;

                $scope.loading = true;
                $http.get("/api/expensereports/filterdata/" + rrid + "?dateType=" + rDateType)
                    .then(function successCallback(response) {
                        $scope.filterData = response.data;
                        $scope.filterDataValid = (typeof $scope.filterData !== "undefined" && $scope.filterData !== null);
                    }, function errorCallBack() {
                        $scope.filterDataValid = false;
                        $scope.error = true;
                    }).then(function () {
                        if ($scope.filterDataValid) {
                            if (typeof $scope.filterData.Executives !== "undefined" && $scope.filterData.Executives !== null && (Object.keys($scope.filterData.Executives).length > 0) && typeof $scope.filterData.TotalHits !== "undefined" && $scope.filterData.TotalHits !== null && $scope.filterData.TotalHits > 0 && $scope.filterData.DateType !== null) { 
                                $scope.selectedExecutives = initSelectedExecutives();
                                $scope.selectedTimeSpan = initTimeSpan();
                                $scope.noItems = false;
                                getReports(rrid, $scope.pagiAmount, $scope.pagiIndex, $scope.filterData.DateType)
                            } else {
                                $scope.loading = false;
                                $scope.noItems = true;
                            }
                        } else {
                            $scope.loading = false;
                            $scope.error = true;
                        }
                    })
            } else {
                $scope.error = true;
            }
        };


        //Datan validointi & virheviestit
        $scope.filterDataValid = false;
        $scope.reportDataValid = false;
        $scope.loading = false;
        $scope.moreResults = false;
        $scope.noResults = false;
        $scope.noItems = false;
        $scope.error = false;

        init();

    }]);
};